import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Col, Row, Typography } from "antd";
import axios from "axios";
import { axiosErrorHandler } from "../../../../swzutils";
import { userHasPermission } from "../../../../swzutils/UserPermissionsUtil";
import InitialSetupStep from "./InitialSetupStep";
import Chart from "react-apexcharts";
import SetupStepType from '../../enums/SetupStepType';
import { LoadingOutlined } from "@ant-design/icons";
import { useAppSelector } from "../../../../store";
import { loggedInUserSelector, selectedTenantSelector } from "../../../../store/slice/auth";
const InitialSetup = () => {
    const [loading, setLoading] = useState(false);
    const [setupSteps, setSetupSteps] = useState([]);
    const [percentComplete, setPercentComplete] = useState(0);
    const loggedInUser = useAppSelector(loggedInUserSelector);
    const selectedTenant = useAppSelector(selectedTenantSelector);
    useEffect(() => {
        if (selectedTenant?.id) {
            loadSetup(selectedTenant);
        }
    }, [selectedTenant?.id]);
    const onStepsLoaded = (steps) => {
        const completedSteps = steps.filter(setupStep => setupStep.complete).length;
        const totalSteps = steps.length;
        setSetupSteps(steps);
        let percentRounded = Math.round(totalSteps <= 0 ? 100 : 100 * (completedSteps / totalSteps));
        setPercentComplete(percentRounded);
    };
    const loadSetup = (tenant) => {
        if (!userHasPermission(loggedInUser, ['admin:setup:list'])) {
            return;
        }
        setLoading(true);
        axios.get(`/admin/v1/setup?tenantId=${tenant.id}`)
            .then(response => onStepsLoaded(response.data))
            .catch(axiosErrorHandler)
            .finally(() => setLoading(false));
    };
    if (percentComplete >= 100) {
        return null;
    }
    if (loading) {
        return _jsxs(Typography.Title, { className: "text-center", children: [_jsx(LoadingOutlined, { spin: true }), " Loading..."] });
    }
    return (_jsxs(_Fragment, { children: [_jsx("h3", { style: { padding: 0, margin: 0 }, children: "Almost there" }), _jsx("h2", { className: "text-2x", children: "Complete initial setup" }), _jsx(Row, { gutter: [16, 16], className: "no-margin", children: _jsx(Col, { xs: 24, children: _jsxs(Row, { children: [_jsx(Col, { md: 16, sm: 12, xs: 24, children: setupSteps.map((setupStep) => {
                                    const setupStepType = SetupStepType.valueOf(setupStep.step);
                                    return (_jsx("div", { style: {
                                            display: 'block',
                                            width: '50%',
                                            float: 'left',
                                            padding: '15px'
                                        }, children: _jsx(InitialSetupStep, { complete: setupStep.complete, description: setupStepType.description, href: setupStepType.path }) }, setupStep.step));
                                }) }), _jsx(Col, { md: 6, sm: 12, xs: 24, children: _jsx(Chart, { options: {
                                        theme: {
                                            monochrome: {
                                                enabled: true,
                                                color: '#25A24E',
                                                shadeTo: 'light',
                                                shadeIntensity: 0.65
                                            }
                                        },
                                        legend: {
                                            position: 'bottom'
                                        },
                                        labels: ["Complete"]
                                    }, type: "radialBar", series: [percentComplete], height: 300, width: "100%" }) })] }) }) }), _jsx("hr", {})] }));
};
export default InitialSetup;
